import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Input, Select, Checkbox, Card, Modal, App as AntdApp } from 'antd';
import { useGroups } from '../../hooks/useGroups';
import { useAgeGroups } from '../../hooks/useAgeGroups';
import { useStudents } from '../../hooks/useStudents';
import { sendNotification } from '../../store/slices/notificationSlice';

const { TextArea } = Input;

const Notification = () => {
  const dispatch = useDispatch();
  const { message } = AntdApp.useApp();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const selectedBranch = useSelector((state) => state.branches.selectedBranch);
  const { groups:groups = [] } = useGroups(selectedBranch?.id);
  const { ageGroups:ageGroups = [] } = useAgeGroups(selectedBranch?.id);
  const { students:students = [] } = useStudents(selectedBranch?.id);

  // Seçim değiştiğinde diğerlerini temizle
  const handleFieldChange = (changedValues, allValues) => {
    const changedKey = Object.keys(changedValues)[0];
    if (changedKey === 'groupId') {
      form.setFieldsValue({ ageGroupId: undefined, studentIds: undefined, sendToAll: false });
    } else if (changedKey === 'ageGroupId') {
      form.setFieldsValue({ groupId: undefined, studentIds: undefined, sendToAll: false });
    } else if (changedKey === 'studentIds') {
      form.setFieldsValue({ groupId: undefined, ageGroupId: undefined, sendToAll: false });
    } else if (changedKey === 'sendToAll') {
      if (changedValues.sendToAll) {
        form.setFieldsValue({ groupId: undefined, ageGroupId: undefined, studentIds: undefined });
      }
    }
  };

  const handleFinish = (values) => {
    setPendingValues({ ...values, branchId: selectedBranch?.id });
    setConfirmVisible(true);
  };

  const handleConfirmSend = async () => {
    setLoading(true);
    setConfirmVisible(false);
    try {
      await dispatch(sendNotification(pendingValues)).unwrap();
      message.success('Bildirim gönderildi!');
      form.resetFields();
    } catch (err) {
      message.error('Bildirim gönderilemedi!');
    } finally {
      setLoading(false);
      setPendingValues(null);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Card title="Mobil Bildirim Gönder" bordered style={{ width: '100%' }}>
        <Form
          form={form}
          layout="vertical"
          onValuesChange={handleFieldChange}
          onFinish={handleFinish}
        >
          <Form.Item name="title" label="Başlık" rules={[{ required: true, message: 'Başlık giriniz' }]}> 
            <Input placeholder="Bildirim başlığı..." />
          </Form.Item>
          <Form.Item name="content" label="İçerik" rules={[{ required: true, message: 'İçerik giriniz' }]}> 
            <TextArea rows={4} placeholder="Bildirim içeriği..." />
          </Form.Item>
          <Form.Item name="groupId" label="Grup">
            <Select placeholder="Grup seçin" allowClear>
              {groups.map(group => (
                <Select.Option key={group.id} value={group.id}>{group.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="ageGroupId" label="Yaş Grubu">
            <Select placeholder="Yaş grubu seçin" allowClear>
              {ageGroups.map(ageGroup => (
                <Select.Option key={ageGroup.id} value={ageGroup.id}>{ageGroup.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="studentIds" label="Öğrenciler">
            <Select mode="multiple" placeholder="Öğrenci seçin" allowClear>
              {students.map(student => (
                <Select.Option key={student.id} value={student.id}>{student.fullName}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="sendToAll" valuePropName="checked">
            <Checkbox>Hepsine gönder</Checkbox>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Gönder
            </Button>
          </Form.Item>
        </Form>
        <Modal
          open={confirmVisible}
          onCancel={() => setConfirmVisible(false)}
          onOk={handleConfirmSend}
          okText="Evet, Gönder"
          cancelText="Vazgeç"
          confirmLoading={loading}
        >
          Bildirimi göndermek istediğinize emin misiniz?
        </Modal>
      </Card>
    </div>
  );
};

export default Notification;